import Tag from 'antd/lib/tag'

interface RoleTagIdProps {
  userRoleName: string
  role: { name: string }
}

export const RoleTagId: React.FC<RoleTagIdProps> = (props) =>
  props.userRoleName === 'Administrator' ? (
    <Tag color='green'>{props.role.name}</Tag>
  ) : (
    <Tag color='orange'>{props.role.name}</Tag>
  )

interface RoleTagProps {
  role: string
  index?: string | number
}

export const RoleTag: React.FC<RoleTagProps> = ({ role, index }) =>
  role === 'Administrator' ? (
    <Tag key={index} color='green'>
      {role}
    </Tag>
  ) : (
    <Tag key={index} color='orange'>
      {role}
    </Tag>
  )
